export default __webpack_public_path__ + "static/media/15.3b95409f.jpg";